// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__2dfG2","circles":"Divider_circles__D4Uai"};